import { useMemo } from 'react';
// components
import { Table } from 'antd';
import useHardware from './HardwareHooks';
// type
import type { ColumnsType } from 'antd/es/table';
import { IData, IColunms, IItemList } from './type';

// style
import './style.less';

const Hardware = () => {
    const { data } = useHardware();

    const columnsArray: ColumnsType<IColunms>[] = useMemo(() => {
        if (!data.length) {
            return [];
        }

        const tempColumnsArray = data.map(item => {
            return item.titleList.map(element => {
                return {
                    title: element.title,
                    dataIndex: element.key,
                    key: element.key,
                    width: 90,
                    render: (_: IData['contentList'][0]) => (
                        <>
                            {_.itemList.map(item => {
                                if (item.link) {
                                    return (
                                        <a href={item.link} target="_blank" rel="noreferrer">
                                            <div>{item.name}</div>
                                        </a>
                                    );
                                }
                                return <div>{item.name}</div>;
                            })}
                        </>
                    )
                };
            });
        });

        return tempColumnsArray;
    }, [data]);

    const datasArray = useMemo(() => {
        if (!data.length) {
            return [];
        }

        const tempDatasArray = data.map((item, index) => {
            return item.dataList.map(element => {
                let itemObj: { [key: string]: any } = {};
                element.contentList.forEach(unit => {
                    itemObj[unit.key] = unit;
                });
                if (index === 0) {
                    //修改link属性，跳转时携带数据
                    let tempParams: string = '';
                    for (const [key, value] of Object.entries(itemObj)) {
                        if (['classify', 'ai', 'cpu', 'sdk', 'os'].includes(key)) {
                            if (value.key === 'cpu' || value.key === 'os') {
                                let tempItemList = [''];
                                tempItemList = value.itemList?.map((item: IItemList) => {
                                    if (item.name !== '--') {
                                        return tempItemList + item.name;
                                    }
                                    return tempItemList;
                                });
                                tempParams = tempParams + '&' + key + '=' + tempItemList.join(',');
                            } else if (value.itemList[0]?.name !== '--') {
                                tempParams = tempParams + '&' + key + '=' + value.itemList[0].name;
                            }
                        } else if (value.key === 'package') {
                            tempParams = value.itemList[0]?.link + tempParams;
                        }
                    }
                    itemObj['package'].itemList[0].link = tempParams.replace(/\s*/g, '').replace(/\uff1a/g, '');
                }
                return itemObj;
            });
        });

        return tempDatasArray;
    }, [data]);

    return (
        <div className="hardware">
            {data.map((item, index) => (
                <div key={item.title} style={{ marginBottom: '60px' }}>
                    <div className="hardware-title">{item.title}</div>
                    <Table columns={columnsArray[index]} dataSource={datasArray[index]} pagination={false} bordered />
                </div>
            ))}
        </div>
    );
};

export default Hardware;
